import { z } from 'my-zod'

const EngineDetailsSchema = z.object({
  Model: z.string().nullish(),
  ModelDescription: z.string().nullish(),
  CountryOfOrigin: z.string().nullish(),
  Serial: z.string().nullish(),
  ProductionHouse: z.string().nullish(),
  ProductionHouseDescription: z.string().nullish(),
  ProductionLine: z.string().nullish(),
  ProductionLineDescription: z.string().nullish(),
  DisplacementMeasure: z.union([z.array(z.any()), z.object({}).nullish()]).nullish()
})

const MarketingInformationSchema = z.object({
  Color: z.string().nullish(),
  ModelSegment: z.string().nullish(),
  ModelSuperSegment: z.string().nullish(),
  ModelSubSegment: z.string().nullish(),
  IsModelSubSegmentMatch: z.boolean().nullish(),
  IsHomologatedEU: z.boolean().nullish(),
  ConsumerReleaseIndicator: z.string().nullish(),
  ManufacturingSubSegment: z.string().nullish(),
  MarketingRegion: z.array(z.any()).nullish()
})

const DepartmentSchema = z.object({
  DepartmentNumber: z.string().nullish(),
  DepartmentGroupID: z.string().nullish(),
  DepartmentGroupIDDescription: z.string().nullish(),
  DepartmentOwner: z.string().nullish()
})

const CustomerSchema = z.object({
  CustomerNumber: z.string().nullish(),
  CustomerName: z.string().nullish()
})

const OrderSchema = z.object({
  CustomerOrderNumber: z.string().nullish(),
  CustomerOrderType: z.string().nullish(),
  OrderCreationDate: z.string().nullish(),
  CustomerOrderShipTo: z.string().nullish(),
  ShipmentDate: z.string().nullish(),
  PurchaseOrderNumber: z.string().nullish()
})

const EmployeeSchema = z.object({
  EmployeeID: z.string().nullish(),
  EmployeeName: z.string().nullish(),
  EmployeeEmailID: z.string().nullish(),
  EmployeeUnitStatus: z.string().nullish(),
  EmployeeUnitStatusDescription: z.string().nullish()
})

const WeightMeasureSchema = z.object({
  Weight: z.number().nullish(),
  UnitofMeasure: z.string().nullish()
})

export const epicVinDataSchema = z.object({
  VehicleID: z.string().min(1, 'Required'),
  AlternateVehicleId: z.string().nullish(),
  ModelNumber: z.string().nullish(),
  ModelYear: z.string().nullish(),
  ModelDescription: z.string().nullish(),
  IsShippable: z.boolean().nullish(),
  ManufacturingSite: z.string().nullish(),
  ProductionHouse: z.string().nullish(),
  ProductionHouseDescription: z.string().nullish(),
  ProductionLine: z.string().nullish(),
  ProductionLineDescription: z.string().nullish(),
  ProductFamily: z.string().nullish(),
  ProductionDate: z.string().nullish(),
  IsElectric: z.boolean().nullish(),
  CountryOfOrigin: z.string().nullish(),
  EUCertificationNumber: z.string().nullish(),
  IsPolarisOwnedUnit: z.boolean().nullish(),
  ManufacturingOrderNumber: z.string().nullish(),
  BuildCode: z.string().nullish(),
  BuildCodeDescription: z.string().nullish(),
  ManufacturerName: z.string().nullish(),
  Disposition: z.string().nullish(),
  ResponsibleUser: z.string().nullish(),
  DelegatedUser: z.string().nullish(),
  IsInternationalModel: z.boolean().nullish(),
  IsLimitedEditionModel: z.boolean().nullish(),
  ProductType: z.string().nullish(),
  ProductLineCode: z.string().nullish(),
  ProductLineCodeDescription: z.string().nullish(),
  BrandCode: z.string().nullish(),
  EngineDetails: EngineDetailsSchema.nullish(),
  VehicleConfiguration: z.array(z.any()).nullish(),
  MarketingInformation: MarketingInformationSchema.nullish(),
  Department: DepartmentSchema.nullish(),
  Customer: CustomerSchema.nullish(),
  Order: OrderSchema.nullish(),
  Employee: EmployeeSchema.nullish(),
  WeightMeasure: WeightMeasureSchema.nullish()
})

export type epicVinDataSchema = z.infer<typeof epicVinDataSchema>
